import React from 'react';
import { motion } from 'framer-motion';
interface NavbarProps {
  onBookClick: () => void;
}
export function Navbar({
  onBookClick
}: NavbarProps) {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-matte-black/80 backdrop-blur-md border-b border-off-white/10" data-id="element-167">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-168">
        <div className="font-playfair text-2xl font-bold text-soft-gold tracking-wider" data-id="element-169">
          KINGSMAN STUDIO
        </div>

        <div className="hidden md:flex items-center gap-8 font-inter text-sm text-off-white" data-id="element-170">
          <a href="#services" className="hover:text-soft-gold transition-colors" data-id="element-171">
            Services
          </a>
          <a href="#barbers" className="hover:text-soft-gold transition-colors" data-id="element-172">
            Barbers
          </a>
          <a href="#reviews" className="hover:text-soft-gold transition-colors" data-id="element-173">
            Reviews
          </a>
          <a href="#location" className="hover:text-soft-gold transition-colors" data-id="element-174">
            Location
          </a>
        </div>

        <motion.button onClick={onBookClick} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-soft-gold text-matte-black px-6 py-2 rounded-full font-inter font-semibold text-sm hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-shadow" data-id="element-175">
          Book Now
        </motion.button>
      </div>
    </motion.nav>;
}